/**
 * User type values
 */
export enum UserTypeEnum {
	FREE = 'free',
	PAID = 'paid',
}
